enum ContainerScope {
  Text = 'Text',
  DropDown = 'DropDown',
  None = 'None',
}

export default ContainerScope;
